/* Un Jour En Or : diaporama de la bannière, avis clients et FAQ.
   Éléments personnalisés, pour fonctionner aussi dans l'éditeur de thème. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 749px)');

  /* ---------- Arrivée par un QR code ou un lien marqué (ex. ?source=amazon) ----------
     La provenance est retenue pour toute la visite (sessionStorage) et la classe html.ujeo-quiet
     est posée : aucune fenêtre surgissante (newsletter, promotion) ne doit s'afficher à ces visiteurs.
     Les blocs newsletter intégrés aux pages restent visibles pour tout le monde. */
  try {
    var ujeoSource = new URLSearchParams(window.location.search).get('source');
    if (ujeoSource) sessionStorage.setItem('ujeo-source', ujeoSource);
    ujeoSource = ujeoSource || sessionStorage.getItem('ujeo-source');
    if (ujeoSource) {
      document.documentElement.classList.add('ujeo-quiet');
      document.documentElement.dataset.ujeoSource = ujeoSource;
    }
  } catch (e) {}

  /* Glisser du doigt vers la gauche ou la droite */
  function ujeoSwipe(el, onSwipe) {
    var x0 = null, y0 = null;
    el.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    el.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) onSwipe(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ---------- Diaporama en fondu ---------- */
  class UjeoSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.ujeo-hero__slide'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.ujeo-hero__dots button'));
      this.index = 0;
      this.delay = parseInt(this.dataset.interval, 10) || 6000;
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i)));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      ujeoSwipe(this, (dir) => this.show(this.index + dir));
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    show(i) {
      if (!this.slides.length) return;
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((s, k) => s.classList.toggle('is-on', k === this.index));
      this.dots.forEach((d, k) => d.classList.toggle('is-on', k === this.index));
      this.start();
    }
    start() {
      this.stop();
      if (reduceMotion || this.slides.length < 2) return;
      this.timer = setTimeout(() => this.show(this.index + 1), this.delay);
    }
    stop() { clearTimeout(this.timer); }
  }

  /* ---------- Avis clients, un par un ---------- */
  class UjeoTestimonials extends HTMLElement {
    connectedCallback() {
      this.items = Array.prototype.slice.call(this.querySelectorAll('.ujeo-voice'));
      this.bars = Array.prototype.slice.call(this.querySelectorAll('.ujeo-voices__bars button'));
      this.index = 0;
      this.delay = parseInt(this.dataset.interval, 10) || 7000;
      this.style.setProperty('--ujeo-voice-delay', this.delay + 'ms');
      this.bars.forEach((b, i) => b.addEventListener('click', () => this.show(i)));
      this.querySelectorAll('[data-dir]').forEach((btn) => {
        btn.addEventListener('click', () => this.show(this.index + parseInt(btn.dataset.dir, 10)));
      });
      this.addEventListener('mouseenter', () => { this.classList.add('is-paused'); this.stop(); });
      this.addEventListener('mouseleave', () => { this.classList.remove('is-paused'); this.start(); });
      ujeoSwipe(this, (dir) => this.show(this.index + dir));
      this.show(0);
    }
    disconnectedCallback() { this.stop(); }
    show(i) {
      if (!this.items.length) return;
      this.index = (i + this.items.length) % this.items.length;
      this.items.forEach((it, k) => it.classList.toggle('is-on', k === this.index));
      this.bars.forEach((b, k) => {
        b.classList.remove('is-on');
        b.classList.toggle('is-done', k < this.index);
      });
      if (this.bars[this.index]) {
        void this.bars[this.index].offsetWidth;
        this.bars[this.index].classList.add('is-on');
      }
      this.start();
    }
    start() {
      this.stop();
      if (reduceMotion || this.items.length < 2 || this.classList.contains('is-paused')) return;
      this.timer = setTimeout(() => this.show(this.index + 1), this.delay);
    }
    stop() { clearTimeout(this.timer); }
  }

  /* ---------- FAQ : recherche et thèmes ---------- */
  class UjeoFaq extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.pills = Array.prototype.slice.call(this.querySelectorAll('[data-topic]'));
      this.groups = Array.prototype.slice.call(this.querySelectorAll('.ujeo-faq__group'));
      this.empty = this.querySelector('.ujeo-faq__empty');
      this.topic = 'all';
      if (this.input) this.input.addEventListener('input', () => this.filter());
      this.pills.forEach((p) => p.addEventListener('click', (e) => {
        e.preventDefault();
        this.pills.forEach((x) => x.removeAttribute('aria-current'));
        p.setAttribute('aria-current', 'true');
        this.topic = p.dataset.topic;
        this.filter();
      }));
    }
    normalize(t) { return t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
    filter() {
      var q = this.input ? this.normalize(this.input.value.trim()) : '';
      var any = false;
      this.groups.forEach((g) => {
        var groupOk = this.topic === 'all' || g.dataset.group === this.topic;
        var shown = 0;
        g.querySelectorAll('details').forEach((d) => {
          var ok = groupOk && (!q || this.normalize(d.textContent).indexOf(q) !== -1);
          d.hidden = !ok;
          if (ok) { shown++; if (q) d.open = true; }
        });
        g.hidden = shown === 0;
        if (shown) any = true;
      });
      if (this.empty) this.empty.hidden = any;
    }
  }

  /* ---------- Fiche produit : barre d'achat fixe sur téléphone ---------- */
  class UjeoStickyAtc extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-ujeo-satc-btn]');
      this.priceEl = this.querySelector('[data-ujeo-satc-price]');
      this.btn.addEventListener('click', () => {
        var main = this.mainButton();
        if (!main) return;
        if (main.disabled) main.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        else main.click();
      });
      this.onScroll = () => { if (!this.ticking) { this.ticking = true; requestAnimationFrame(() => { this.ticking = false; this.update(); }); } };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.update();
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); window.removeEventListener('resize', this.onScroll); }
    mainButton() { return document.querySelector('.product-form__submit'); }
    update() {
      var main = this.mainButton();
      var footer = document.querySelector('.ujeo-footer');
      var show = false;
      if (main && isMobile.matches) {
        var past = main.getBoundingClientRect().bottom < 0;
        var atEnd = footer && footer.getBoundingClientRect().top < window.innerHeight;
        show = past && !atEnd;
      }
      if (show && main) {
        var price = document.querySelector('.product__info-container .price');
        if (price) {
          var item = price.classList.contains('price--on-sale') ? price.querySelector('.price__sale .price-item--last') : price.querySelector('.price__regular .price-item--regular');
          if (item) this.priceEl.textContent = item.textContent.trim();
        }
        this.btn.disabled = main.disabled;
        this.btn.textContent = main.disabled ? (main.textContent.trim() || 'Épuisé') : this.btn.dataset.label;
      }
      this.classList.toggle('is-on', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      this.btn.tabIndex = show ? 0 : -1;
    }
  }

  /* ---------- Fiche produit : description repliable sur téléphone ---------- */
  function ujeoClampDescriptions() {
    if (!isMobile.matches) return;
    document.querySelectorAll('.product__description').forEach(function (d) {
      if (d.dataset.ujeoClamp || d.scrollHeight < 340) return;
      d.dataset.ujeoClamp = '1';
      d.classList.add('ujeo-clamp');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ujeo-clamp__btn';
      b.textContent = 'Lire la suite';
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var open = d.classList.toggle('is-open');
        b.textContent = open ? 'Réduire' : 'Lire la suite';
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) d.scrollIntoView({ block: 'nearest' });
      });
      d.after(b);
    });
  }
  ujeoClampDescriptions();
  document.addEventListener('shopify:section:load', ujeoClampDescriptions);

  /* ---------- Fiche produit : galerie filtrée par coloris ----------
     Chaque photo dont le texte alternatif COMMENCE par le nom d'un coloris
     (ex. « Rose et Or — urne Merci ») n'est montrée que pour ce coloris.
     Les photos sans coloris en tête restent visibles pour tous.
     Tant qu'aucun texte alternatif ne commence par un coloris, rien ne change. */
  function ujeoGalleryFilter() {
    var norm = function (t) { return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim(); };
    var normFilename = function (src) {
      if (!src) return '';
      var name = src.split('/').pop().split('?')[0].replace(/\.[a-z0-9]+$/i, '');
      name = name.replace(/[-_]+/g, ' ').replace(/\s+\d+$/, '');
      return norm(name);
    };
    document.querySelectorAll('product-info').forEach(function (info) {
      var gallery = info.querySelector('media-gallery');
      if (!gallery || gallery.dataset.ujeoFilter) return;
      gallery.dataset.ujeoFilter = '1';
      function optionValues() {
        var vals = [];
        info.querySelectorAll('variant-selects input[type="radio"], variant-selects select option').forEach(function (el) {
          var v = norm(el.value);
          if (v && vals.indexOf(v) === -1) vals.push(v);
        });
        return vals.sort(function (a, b) { return b.length - a.length; });
      }
      function selectedValues() {
        var out = [];
        info.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select').forEach(function (el) { out.push(norm(el.value)); });
        return out;
      }
      function apply() {
        var values = optionValues();
        if (!values.length) return;
        var selected = selectedValues();
        var items = gallery.querySelectorAll('li[data-media-id], li[data-target]');
        var tagged = 0;
        items.forEach(function (li) {
          var img = li.querySelector('img');
          var alt = norm(img && img.alt);
          var owner = '';
          for (var i = 0; i < values.length; i++) { if (alt.indexOf(values[i]) === 0) { owner = values[i]; break; } }
          if (!owner) {
            var fname = normFilename(img && img.src);
            for (var j = 0; j < values.length; j++) { if (fname.indexOf(values[j]) === 0) { owner = values[j]; break; } }
          }
          li.dataset.ujeoOwner = owner;
          if (owner) tagged++;
        });
        if (!tagged) return;
        items.forEach(function (li) { var o = li.dataset.ujeoOwner; li.hidden = !!(o && selected.indexOf(o) === -1); });
        gallery.querySelectorAll('slider-component').forEach(function (s) { if (s.resetPages) s.resetPages(); else if (s.initPages) s.initPages(); });
        var viewer = gallery.querySelector('[id^="GalleryViewer"]');
        if (!viewer) return;
        var active = viewer.querySelector('li[data-media-id].is-active:not([hidden])');
        var first = viewer.querySelector('li[data-media-id]:not([hidden])');
        if (!active && first && gallery.setActiveMedia) gallery.setActiveMedia(first.dataset.mediaId, false);
      }
      apply();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, function () { apply(); });
      document.addEventListener('ujeo:gallery-refresh', apply);
    });
  }
  ujeoGalleryFilter();
  document.addEventListener('shopify:section:load', ujeoGalleryFilter);

  /* ---------- Version « grande maison » : apparitions, ligne qui s'écrit, films ----------
     Rien de tout cela ne s'active si l'utilisateur a réduit les animations, ni dans l'éditeur de thème. */
  (function () {
    var html = document.documentElement;
    if (reduceMotion || (window.Shopify && Shopify.designMode) || !('IntersectionObserver' in window) || /ujeo-static/.test(location.search)) return;
    html.classList.add('ujeo-motion');
    setTimeout(function () { html.classList.add('ujeo-ready'); }, 120);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target._ujeoWrite || e.target;   /* ligne qui s'écrit : on observe son parent, car le texte masqué n'est jamais « vu » */
        t.classList.add('is-in'); io.unobserve(e.target);
      });
    }, { threshold: .2 });
    function observe() {
      document.querySelectorAll('[data-ujeo-reveal]:not(.is-in), .ujeo-spread:not(.is-in)').forEach(function (el) { io.observe(el); });
      document.querySelectorAll('.ujeo-write:not(.ujeo-cover__accent):not(.is-in)').forEach(function (el) {
        var p = el.parentElement; if (!p) return; p._ujeoWrite = el; io.observe(p);
      });
      /* filet de sécurité : tout ce qui n'est pas apparu au bout de 4 s apparaît */
      setTimeout(function () { document.querySelectorAll('.ujeo-write:not(.is-in)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) el.classList.add('is-in'); }); }, 4000);
    }
    observe();
    document.addEventListener('shopify:section:load', observe);
    var saveData = navigator.connection && navigator.connection.saveData;
    document.querySelectorAll('.ujeo-cover').forEach(function (cover) {
      var v = cover.querySelector('.ujeo-cover__video');
      if (!v || isMobile.matches || saveData) return;
      var start = function () {
        v.src = v.dataset.src;
        var p = v.play();
        if (p && p.then) p.then(function () { cover.classList.add('is-playing'); }).catch(function () {});
      };
      if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
    });
    document.querySelectorAll('.ujeo-spread').forEach(function (spread) {
      var v = spread.querySelector('.ujeo-spread__video');
      if (!v || saveData) return;
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!v.getAttribute('src')) v.src = v.dataset.src;
            var p = v.play();
            if (p && p.then) p.then(function () { spread.classList.add('is-playing'); }).catch(function () {});
          } else { v.pause(); }
        });
      }, { threshold: .3 });
      vio.observe(spread);
    });
  })();

  if (!customElements.get('ujeo-sticky-atc')) customElements.define('ujeo-sticky-atc', UjeoStickyAtc);
  if (!customElements.get('ujeo-slideshow')) customElements.define('ujeo-slideshow', UjeoSlideshow);
  if (!customElements.get('ujeo-testimonials')) customElements.define('ujeo-testimonials', UjeoTestimonials);
  if (!customElements.get('ujeo-faq')) customElements.define('ujeo-faq', UjeoFaq);
})();
